<div class="col-md-12">
  <div class="panel panel-default" style="position: relative;">
    <div class="panel-heading" style="background-color: #064560; color:#ffffff">
      Map <app-help-docs-links recordType="map"></app-help-docs-links>
    </div>
    <div class="panel-body">
      <div class="spinner-container" *ngIf="mapLoading" >
        <i class="fa fa-pulse fa-spinner fa-4x" style="color: #064560;"></i>
      </div>
      <div id="mapDiv">
        <div id="HomeButton"></div>

        <!-- /.row -->
        <div id="zoomToolbar" class="btn-toolbar">
          <div class="btn-group">
            <button id="zoomIn-button" class="btn btn-primary" (click)="zoomIn()">
              <span class="fa fa-plus"></span>
            </button>
            <button id="zoomOut-button" class="btn btn-primary" (click)="zoomOut()">
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
